import ItemViewState from '../store/schema/ItemViewState';
import { action } from 'satcheljs/lib/legacy';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';

const removeInfoBarMessageInReadingPane = action('removeInfoBarMessageInReadingPane')(
    function removeInfoBarMessageInReadingPane(viewState: ItemViewState, messageId: string) {
        removeInfoBarMessage(viewState, messageId, viewState.itemId);
    }
);

export default removeInfoBarMessageInReadingPane;
